import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';


import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  ComplianceAreaService,
  TenantService
} from '../../_services/index';

import {ClientITProfile, ComplianceArea} from '../../_models/index';
import {LoginHelper} from '../../helpers';
import {PolicyService} from "../../_services/policy.service";
import {AssessmentService} from "../../_services/assessment.service";
import {Constants} from "../../helpers/constants";
import {Policy} from "../../_models/policy";
import {TrainingService} from "../../_services/training.service";
import {AuditService} from "../../_services/audit.service";
import {ImplementationControlStatementService} from "../../_services/implementationControlStatement.service";
import {MappingService} from "../../_services/mapping.service";
import {ActionItemService} from "../../_services/actionItem.service";
import {DictionaryService} from "../../_services/dictionary.service";
import {DocumentRequestService} from "../../_services/documentRequest.service";
import {WorkstreamService} from "../../_services/workstream.service";
import {ReferenceResourceService} from "../../_services/referemceResource.service";
import {RecommendedSolutionService} from "../../_services/recommendedSolution.service";
import {OidcService} from "../../_services/oidc.service";

const now = new Date();

@Component({
    standalone: false,
  selector: 'tenant-component',
  templateUrl: 'tenant.component.html',
  styleUrls: ['./tenant.component.css'],
})

export class TenantComponent implements OnInit {
  loading = false;
  tenant: any;

  public complianceAreas: ComplianceArea[];
  public policies: Policy[];
  public implementationControlStatementsTree: any[];
  public actionPlanTemplatesTree: any[];


  public profiles: ClientITProfile[];
  public assessments: any[];
  public trainings: any[];
  public audits: any[];
  public mappingTemplates: any[];
  public dictionaryItemTree: any[];
  public documentRequestGroups: any[];
  public workstreams: any[];
  public referenceResources: any[];
  public recommendedSolutions: any[];

  selectedComplianceAreas: ComplianceArea[] = [];
  selectedPolicies: Policy[];
  selectedTreeImplementationControlStatements: any[] = [];
  selectedTreeActionPlanTemplates: any[] = [];
  selectedProfiles: ClientITProfile[];
  selectedAssessments: any[];
  selectedTrainings: any[];
  selectedAudits: any[];
  selectedMappingTemplates: any[];
  selectedDictionaryItems: any[] = [];
  selectedDocumentRequestGroups: any[];
  selectedWorkstreams: any[];
  selectedReferenceResources: any[];
  selectedRecommendedSolutions: any[];

  constructor(
    public dialogRef: MatDialogRef<TenantComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public route: ActivatedRoute,
    public tenantService: TenantService,
    public alertService: AlertService,
    public complianceAreaService: ComplianceAreaService,
    public policyService: PolicyService,
    public implementationControlStatementService: ImplementationControlStatementService,
    public actionPlanTemplateService: ActionItemService,
    public clientProfileService: ClientProfileService,
    public assessmentService: AssessmentService,
    public trainingService: TrainingService,
    public documentRequestService: DocumentRequestService,
    public auditService: AuditService,
    public mappingService: MappingService,
    public dictionaryService: DictionaryService,
    public workstreamService: WorkstreamService,
    public referenceResourceService: ReferenceResourceService,
    public recommendedSolutionService: RecommendedSolutionService,
    public oidcService: OidcService,
    public authenticationService: AuthenticationService) {
  }

  ngOnInit() {

    let tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.tenant = Object.assign({}, this.data.tenant);

    this.complianceAreaService.getComplianceAreas().subscribe(d => {
      this.complianceAreas = d;
      const items = this.tenant.existingComplianceAreas;
      this.selectedComplianceAreas = d.filter(m => items.find(i => i == m.name));
    });
    this.workstreamService.getWorkstreams().subscribe(d => {
      this.workstreams = d;
      const items = this.tenant.existingWorkstreams;
      this.selectedWorkstreams = d.filter(m => items.find(i => i == m.name));
    });
    this.referenceResourceService.getAll().subscribe(d => {
      this.referenceResources = d;
      const items = this.tenant.existingReferenceResources;
      this.selectedReferenceResources = d.filter(m => items.find(i => i == m.name));
    });
    this.recommendedSolutionService.getAll().subscribe(d => {
      this.recommendedSolutions = d;
      const items = this.tenant.existingRecommendedSolutions;
      this.selectedRecommendedSolutions = d.filter(m => items.find(i => i == m.name));
    });
    this.policyService.getAllPolicys().subscribe(d => {
      this.policies = d;
      const items = this.tenant.existingPolicies;
      this.selectedPolicies = d.filter(m => items.find(i => i == m.name));
    });
    this.implementationControlStatementService.getAllImplementationControlStatementsFull().subscribe(d => {
      const items = this.tenant.existingImplementationControlStatements;
      this.implementationControlStatementsTree = [];
      const categories = [];
      d.forEach(i => {
        if (categories.indexOf(i.category) < 0) {
          categories.push(i.category);
        } else {
          return;
        }
        let all = true;
        this.implementationControlStatementsTree.push({
          data: {category: i.category}, children: d.filter(c => c.category == i.category).map(c => {
            const item = {data: c};
            if (items.indexOf(c.name) >= 0) {
              this.selectedTreeImplementationControlStatements.push(item)
            } else {
              all = false;
            }
            return item;
          })
        });
        if (all) {
          this.selectedTreeImplementationControlStatements.push(this.implementationControlStatementsTree[this.implementationControlStatementsTree.length - 1]);
        }
      });
    });
    this.actionPlanTemplateService.getAllActionItemsFull().subscribe(d => {
      const items = this.tenant.existingActionPlanTemplates;
      this.actionPlanTemplatesTree = [];
      const categories = [];
      d.forEach(i => {
        if (categories.indexOf(i.category) < 0) {
          categories.push(i.category);
        } else {
          return;
        }
        let all = true;
        this.actionPlanTemplatesTree.push({
          data: {category: i.category}, children: d.filter(c => c.category == i.category).map(c => {
            const item = {data: c};
            if (items.indexOf(c.name) >= 0) {
              this.selectedTreeActionPlanTemplates.push(item)
            } else {
              all = false;
            }
            return item;
          })
        });
        if (all) {
          this.selectedTreeActionPlanTemplates.push(this.actionPlanTemplatesTree[this.actionPlanTemplatesTree.length - 1]);
        }
      });
    });
    this.clientProfileService.getClientProfiles(Constants.RiskSpongeMaster).subscribe(d => {
      this.profiles = d;
      const items = this.tenant.existingProfiles;
      this.selectedProfiles = d.filter(m => items.find(i => i == m.name));
    });
    this.assessmentService.getAllAssessments().subscribe(d => {
      this.assessments = d;
      const items = this.tenant.existingAssessments;
      this.selectedAssessments = d.filter(m => items.find(i => i == m.quizData.name));
    });
    this.trainingService.getAllTrainings().subscribe(d => {
      this.trainings = d;
      const items = this.tenant.existingTrainings;
      this.selectedTrainings = d.filter(m => items.find(i => i == m.quizData.name));
    });
    this.auditService.getAllAudits().subscribe(d => {
      this.audits = d;
      const items = this.tenant.existingAudits;
      this.selectedAudits = d.filter(m => items.find(i => i == m.name));
    });
    this.mappingService.getMappingTemplates().subscribe(d => {
      this.mappingTemplates = d;
      const items = this.tenant.existingMappingTemplates;
      this.selectedMappingTemplates = d.filter(m => items.find(i => i == m.name));
    });
    this.dictionaryService.get(['Vendor', 'Service']).subscribe(d => {
      const items = d;
      this.dictionaryItemTree = [];
      d.forEach(i => {
        if (i.dictionary == 'Service') {
          return;
        }
        let all = true;
        let any = false;
        this.dictionaryItemTree.push({
          data: i, children: d.filter(c => c.parentId == i.itemId).map(c => {
            const item = {data: c};
            if (this.tenant.existingDictionaryItems.find(a => a.name == c.name && a.parent == c.parent)) {
              this.selectedDictionaryItems.push(item);
              any = true;
            } else {
              all = false;
            }
            return item;
          })
        });
        if (all) {
          this.selectedDictionaryItems.push(this.dictionaryItemTree[this.dictionaryItemTree.length - 1]);
        } else if (any) {
          this.dictionaryItemTree[this.dictionaryItemTree.length - 1].partialSelected = true;
        }
      });
    });
    this.documentRequestService.getDocumentRequestGroups().subscribe(d => {
      this.documentRequestGroups = d;
      const items = this.tenant.existingDocumentRequestGroups;
      this.selectedDocumentRequestGroups = d.filter(m => items.find(i => i == m.name));
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSave() {
    this.loading = true;

    this.alertService.clear();

    this.tenant.existingComplianceAreas = (this.selectedComplianceAreas || []).map(a => a.name);
    this.tenant.existingPolicies = (this.selectedPolicies || []).map(a => a.name);
    this.tenant.existingImplementationControlStatements = (this.selectedTreeImplementationControlStatements || []).filter(a => a.data.name).map(a => a.data.name);
    this.tenant.existingActionPlanTemplates = (this.selectedTreeActionPlanTemplates || []).filter(a => a.data.name).map(a => a.data.name);
    this.tenant.existingProfiles = (this.selectedProfiles || []).map(a => a.name);
    this.tenant.existingAssessments = (this.selectedAssessments || []).map(a => a.quizData.name);
    this.tenant.existingTrainings = (this.selectedTrainings || []).map(a => a.quizData.name);
    this.tenant.existingAudits = (this.selectedAudits || []).map(a => a.name);
    this.tenant.existingMappingTemplates = (this.selectedMappingTemplates || []).map(a => a.name);
    this.tenant.existingDictionaryItems = (this.selectedDictionaryItems || []).map(a => a.data);
    this.dictionaryItemTree.filter(a => a.partialSelected).forEach(a => this.tenant.existingDictionaryItems.push(a.data));
    this.tenant.existingDocumentRequestGroups = (this.selectedDocumentRequestGroups || []).map(a => a.name);
    this.tenant.existingWorkstreams = (this.selectedWorkstreams || []).map(a => a.name);
    this.tenant.existingReferenceResources = (this.selectedReferenceResources || []).map(a => a.name);
    this.tenant.existingRecommendedSolutions = (this.selectedRecommendedSolutions || []).map(a => a.name);

    this.tenantService.update(this.tenant)
      .subscribe(
        data => {
          this.alertService.success('The data of tenant was updated.', true);

          this.loading = false;

          this.onClose();
        },
        error => {
          this.loading = false;
          const message = "An error occurred while updating tenant.";
          this.alertService.error(message);
        });
  }

  getCustomer() {
    this.tenantService.getAwsCustomer(this.tenant.tenantId, this.tenant.awsMarketplaceToken).subscribe(e => {
      this.tenant.awsMarketplaceCustomerAccountId = e.awsMarketplaceCustomerAccountId;
      this.tenant.awsMarketplaceProductCode = e.awsMarketplaceProductCode;
      this.tenant.awsMarketplaceCustomerIdentifier = e.awsMarketplaceCustomerIdentifier;
    });
  }

  getEntitlements(){
    this.tenantService.getAwsEntitlements(this.tenant.tenantId, {AWSMarketplaceCustomerAccountId: this.tenant.awsMarketplaceCustomerAccountId, AWSMarketplaceProductCode: this.tenant.awsMarketplaceProductCode, AWSMarketplaceCustomerIdentifier: this.tenant.awsMarketplaceCustomerIdentifier}).subscribe(e => {
      this.tenant.awsMarketplaceMaxProjects = e;
    });
  }
}
